<form [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <app-form-field
    controlId="login-identifier"
    label="EMAIL OR EMPLOYEE ID"
    [required]="true"
    [error]="identifierError()"
  >
    <app-text-input
      formControlName="userNameOrPhone"
      controlId="login-identifier"
      type="text"
      placeholder="e.g. jsmith@coreehs.com"
      autocomplete="username"
      [invalid]="!!identifierError()"
    />
  </app-form-field>

  <app-form-field
    controlId="login-password"
    label="PASSWORD"
    [required]="true"
    [error]="passwordError()"
  >
    <app-text-input
      formControlName="password"
      controlId="login-password"
      type="password"
      placeholder="Password"
      autocomplete="current-password"
      [revealable]="true"
      [invalid]="!!passwordError()"
    />
  </app-form-field>

  <div class="pw-row">
    <label class="check">
      <input type="checkbox" formControlName="rememberMe" />
      Keep me signed in
    </label>

    <button type="button" class="pw-link" (click)="forgotPassword.emit()">Forgot password?</button>
  </div>

  @if (errorMessage()) {
    <!-- role="alert" so the failure is announced, not just repainted. -->
    <p class="login-inline-error" role="alert">{{ errorMessage() }}</p>
  }

  <button class="btn btn-gold btn-block" type="submit" [disabled]="busy()">
    @if (busy()) {
      <app-spinner [size]="13" label="Signing in" />
      Signing in
    } @else {
      Sign in
    }
  </button>
</form>
